export default {
  datepicker: {
    invalid: 'Enter a valid date (dd/mm/yyyy)',
    openPicker: 'Open date picker',
  },
  errorScreen: {
    actions: {
      callUs: 'Call us',
      createNewAppointment: 'Create new appointment',
      goBack: 'Close',
    },
    header: 'Booking error',
    messages: {
      default: 'An unexpected error occurred. Please try again later',
      internalServerError: 'Internal server error. Please try again later',
      network: 'Network error. Please check your connection and try again.',
      noLocations: 'No locations available',
      timeffTimeoutVelthuis:
        'We are currently unable to book an appointment for you. Please call us or try again later.',
      timeffTimeoutXpert:
        'We are currently unable to book an appointment for you. Please call us or try again later.',
      zdCode: 'Invalid referral code',
    },
  },
  fields: {
    dateOfBirth: {
      error: 'Please enter a valid date of birth',
      label: 'Date of birth',
      placeholder: 'DD/MM/YYYY',
    },
    email: {
      error: 'Please enter a valid email address',
      label: 'Email address',
      placeholder: 'john.doe@mail.com',
    },
    firstName: {
      error: 'Please enter your name',
      label: 'Name',
      placeholder: 'John',
    },
    gender: {
      error: 'Please select your gender',
      label: 'Gender',
      options: {
        female: 'Female',
        male: 'Male',
        other: 'Other',
        unknown: 'Unknown',
      },
    },
    height: {
      error: 'Please enter a valid height',
      label: 'Height (cm)',
    },
    houseNumber: {
      error: 'Please enter your house number',
      label: 'House number',
      placeholder: '12a',
    },
    initials: {
      error: 'Please enter your initials',
      label: 'Initials',
      placeholder: 'JD',
    },
    lastName: {
      error: 'Please enter your surname',
      label: 'Surname',
      placeholder: 'Doe',
    },
    phone: {
      error: 'Please enter a valid telephone number',
      label: 'Telephone number',
      placeholder: 'XXX-XXX XXXX',
    },
    postalCode: {
      error: 'Please enter a valid postal code',
      label: 'Postal code',
      placeholder: '1234 AB',
    },
    weight: {
      error: 'Please enter a valid weight',
      label: 'Weight (kg)',
    },
  },
  navHeader: 'Book an appointment',
  successScreen: {
    actions: {
      close: 'Close',
    },
    header: 'Appointment confirmed',
  },
}
